export default "__VITE_PUBLIC_ASSET__cd3cc77d__"